// @ts-check
// Chamadas da LGPD não consentida e da base legal das comunicações de marketing (2.0.0, contrato 09 de campanhas base,
// seção 6.8): situação de uma pessoa, marcar, registrar consentimento e a configuração da escola.
import { api } from './api-client.js';

/**
 * @typedef {{ isEligible: boolean, basis: string | null, reason: string | null }} MarketingChannelStatus
 * @typedef {{
 *   personId: string, isOptedOut: boolean, optOut: { at: string | null, source: string | null } | null, isMinor: boolean | null,
 *   requiresGuardian: boolean | null,
 *   isAnonymized: boolean, funnelEntryConsent: string, isInFunnel: boolean, channels: Record<string, MarketingChannelStatus>,
 *   latestConsentRecord: { id: string, name: string, consentAction: string, source: string | null, recordedAt: string } | null,
 *   pendingConsentRequest: { at: string, source: string | null } | null, canMarkOptOut: boolean, canRegisterConsent: boolean,
 * }} MarketingStatus
 * @typedef {{ funnelEntryConsent: 'OFF' | 'CONTACT' | 'FAMILY_GUARDIANS', serviceRelationshipStages: string[],
 *   funnelEntryWhatsappSources: string[] | null, optedOutCount: number | null, canUpdate: boolean }} MarketingConsentSettings
 */

/** @param {string} personId @returns {Promise<MarketingStatus>} */
export async function fetchMarketingStatus(personId) {
  const body = await api.get(`/rest/privacy/people/${encodeURIComponent(personId)}/marketing-status`);
  return body.data.marketingStatus;
}

/** @param {string} personId @param {{ note?: string }} input @returns {Promise<MarketingStatus>} */
export async function markMarketingOptOut(personId, input = {}) {
  const body = await api.post(`/rest/privacy/people/${encodeURIComponent(personId)}/marketing-opt-out`, input.note ? { note: input.note } : {});
  return body.data.marketingStatus;
}

/**
 * @param {string} personId @param {{ source: string, evidence: string, grantedByPersonId?: string | null }} input
 * @returns {Promise<MarketingStatus>}
 */
export async function registerMarketingConsent(personId, input) {
  const body = await api.post(`/rest/privacy/people/${encodeURIComponent(personId)}/marketing-consent`, {
    source: input.source, evidence: input.evidence, ...(input.grantedByPersonId ? { grantedByPersonId: input.grantedByPersonId } : {}),
  });
  return body.data.marketingStatus;
}

/** @returns {Promise<MarketingConsentSettings>} */
export async function fetchMarketingConsentSettings() {
  const body = await api.get('/rest/privacy/marketing-settings');
  return body.data.marketingConsentSettings;
}

/**
 * @param {{ funnelEntryConsent?: string, serviceRelationshipStages?: string[] }} patch
 * @returns {Promise<MarketingConsentSettings>}
 */
export async function updateMarketingConsentSettings(patch) {
  const body = await api.patch('/rest/privacy/marketing-settings', patch);
  return body.data.marketingConsentSettings;
}
